import React from "react";
import { Menu } from "discover.medical.react-component-library";
import { Avatar } from "./index.styled";
import { useStore } from "../../store";
import Personalized from "./Personalized";
import NotPersonalized from "./NotPersonalized";
import ErrorBoundary from "../ErrorBoundary";

const LogInMenu = ({ className, onMenuItemClick, isOpen, toggleMenu }) => {
  const {
    customLinks,
    messaging,
    userDetails,
    linkURLs,
  } = useStore().personalization.data.userHeader;

  // no messaging, don't render anything
  if (!messaging || messaging.error || !userDetails) {
    return null;
  }
  return (
    <ErrorBoundary team="cd.bauhaus">
      <Menu
        pinBody={false}
        isOpen={isOpen}
        toggleMenu={toggleMenu}
        className={className}
        triggerAnchor={{
          vertical: "top",
          horizontal: "center",
        }}
        menuAnchor={{
          vertical: "bottom",
          horizontal: "center",
        }}
        trigger={
          <Avatar
            aria-label={isOpen ? "close user menu" : "open user menu"}
            data-testid={isOpen ? "user-toggle-open" : "user-toggle-closed"}
            borderColor="quaternary"
            children={userDetails.initials}
            foregroundColor={
              userDetails.initials ? "buttonprimary" : "quaternary"
            }
          />
        }
      >
        {userDetails.state.personalized ? (
          <Personalized
            messaging={messaging}
            userDetails={userDetails}
            linkURLs={linkURLs}
            customLinks={customLinks}
            onMenuItemClick={onMenuItemClick}
          />
        ) : (
          <NotPersonalized
            messaging={messaging}
            linkURLs={linkURLs}
            affiliationName={userDetails.affiliationName}
          />
        )}
      </Menu>
    </ErrorBoundary>
  );
};

export default LogInMenu;
